import React from 'react';
import { useTranslation } from 'react-i18next';
import emptyIllustration from '@src/assets/images/new-no-data.svg';
import { StyledExportHistoryEmpty } from './index.style';

const ExportHistoryEmpty = () => {
  const { t } = useTranslation();

  return (
    <StyledExportHistoryEmpty>
      <div className="empty-illustration">
        <img src={emptyIllustration} alt="" />
      </div>
      <span className="empty-message">{t('emptyExportHistory')}</span>
    </StyledExportHistoryEmpty>
  );
};

export default ExportHistoryEmpty;
